import { Injectable } from "@angular/core";
import { BehaviorSubject } from "rxjs";

@Injectable({
  providedIn: "root",
})
export class UserDataService {
  private userDataSubject = new BehaviorSubject<boolean>(false);

  // Observable to watch for changes in user data
  userData$ = this.userDataSubject.asObservable();

  // Method to trigger the fetchUserData() functionality
  triggerFetchUserData(): void {
    this.userDataSubject.next(true);
  }
}
